export default "__VITE_ASSET__CSG8tBkB__"